import styled from 'styled-components';
import MuiButton from '@mui/material/Button';
import MuiIconButton from '@mui/material/IconButton';

export const Button = styled(MuiButton)`
  &.MuiButtonBase-root {
    border-radius: 8px;
  }

  &.MuiButton-contained {
    &.MuiButton-containedPrimary {
      background-color: ${(props) => props.theme.primary.main};

      &:hover {
        background-color: ${(props) => props.theme.button.active};
      }
    }

    &.small {
      min-width: unset;
      padding: 6px 10px;
      font-size: 12px;
      line-height: 16px;

      &.tag {
        padding: 4px 6px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }

  &.MuiButton-outlined {
    color: ${(props) => props.theme.palette.text.primary};
    border-color: ${(props) => props.theme.palette.text.primary};

    &:hover {
      color: ${(props) => props.theme.primary.main};
      border-color: ${(props) => props.theme.primary.main};
    }

    &.view-detail {
      color: ${(props) => props.theme.button.outlined};
      border-color: ${(props) => props.theme.button.outlined};
    }

    &.small {
      min-width: unset;
      padding: 6px 10px;
      font-size: 12px;
      line-height: 16px;
    }
  }

  &.MuiButton-warning {
    background-color: ${(props) => props.theme.button.warning.background};
    color: ${(props) => props.theme.button.warning.color};
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

    &:hover {
      background-color: ${(props) => props.theme.button.warning.hover};
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
  }

  &.button-icon {
    min-width: unset;
    padding: 5px 8px;

    &.small {
      .MuiSvgIcon-root {
        font-size: 20px;
      }
    }
  }
`;

export const IconButton = styled(MuiIconButton)``;
